import { render } from "./Index.vue?vue&type=template&id=51d4e53e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=51d4e53e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51d4e53e"

export default script